<template>
  <v-card>
    <v-card-title>Bayii Düzenle</v-card-title>
    <v-container>
      <v-row class="mx-2">
        <v-col cols="12">
          <v-text-field v-model="financier.name" label="Bayii Adı" />
        </v-col>
        <!-- <v-col cols="12">
          <v-text-field v-model="financier.website" label="Website" />
        </v-col> -->
        <v-col cols="12">
          <v-text-field v-model="financier.firmaEmail" label="Mail Adresi" />
        </v-col>
        <v-col cols="12">
          <v-text-field v-model="financier.limit" label="Limit" />
        </v-col>
        <!-- <v-col cols="12">
          <v-text-field
            v-model="financier.companyApiKey"
            label="Api Key"
            disabled
          />
        </v-col> -->
        <v-col cols="12">
          <v-text-field v-model="financier.firmaSifre" label="Şifre" disabled />
        </v-col>
        <!-- <v-col cols="12">
          <v-text-field v-model="financier.firmaSifre2" label="Şİfre Tekrar"  />
        </v-col> -->
        <v-col cols="12">
          <v-switch
            v-model="financier.active"
            :label="financier.active ? 'Aktif' : 'Deaktif'"
          ></v-switch>
        </v-col>
      </v-row>
    </v-container>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="$router.go(-1)">Geri</v-btn>
      <v-btn text @click="handleUpdate">Güncelle</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "view-financier",
  data() {
    return {
      financier: {},
    };
  },
  methods: {
    handleUpdate() {
      this.$swal({
        title: "Bayii Güncelleme Onayı",
        text:
          this.financier._id +
          " numaralı Bayiiyi güncellemek istediğinizden emin misiniz?",
        icon: "warning",
        buttons: {
          cancel: "İptal",
          ok: "Güncelle",
        },
      }).then((confirm) => {
        if (confirm) {
          this.updateFinancier(this.financier);
        }
      });
    },
  },
  created() {
    this.financier = this.getFinancier(this.$route.params.id);
  },
};
</script>
